import { IModule, IModuleBuilder } from "app/IModule";
import { BidEditorDisablePeriodReducer } from "./bidEditorDisablePeriods/bidEditorDisablePeriods.reducer";
import { DeliveryPeriodBulkUploadResponseReducer } from "features/deliveryPeriods/deliveryPeriod.reducer";
import permissions from "common/security/permissions";
import React from "react";

export default class BidEditorModule implements IModule {

    build(builder: IModuleBuilder) {
        builder.addPermissionedRoute("/bid-editor/:commodityId", permissions.UpdateBid, React.lazy(() => import("./BidEditor.page")));
        builder.addPermissionedRoute("/bid-editor", permissions.UpdateBid, React.lazy(() => import("./BidEditor.page")));
        builder.addReducer("bidEditorDisablePeriods", new BidEditorDisablePeriodReducer());
        builder.addRoute("/bid-editor-import", React.lazy(() => import("./UploadBids.page"))); 
        builder.addReducer("deliveryPeriodsBulkUploadResponse", new DeliveryPeriodBulkUploadResponseReducer());
    }
}